import classNames from 'classnames';
import React from 'react';
import EfImg from '../ef-img';
import './index.scss';

interface EfCardsAppAItemProps {
    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 主标题
     */
    title?: string;
    /**
     * 描述
     */
    desc?: string;
}
interface EfCardsAppAProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 列表
     */
    list: EfCardsAppAItemProps[];
}

/**
 * 维护:谢保林
 *
 * 卡片列表
 */
const EfCardsAppA: React.FC<EfCardsAppAProps> = ({ list, className }) => {
    const prefixCls = `ef-cards-app-a`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
    });

    return (
        <div className={classes}>
            {list?.map((item: EfCardsAppAItemProps, index: number) => (
                <div key={index} className={`${prefixCls}-item`}>
                    <div className={`${prefixCls}-item-msg`}>
                        {item.title && <div className={`${prefixCls}-item-title`}>{item.title}</div>}
                        {item.desc && <div className={`${prefixCls}-item-desc`}>{item.desc}</div>}
                    </div>
                    <div className={`${prefixCls}-item-img`}>
                        <EfImg pc={item.pc} h5={item.h5} />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default EfCardsAppA;
